/**
 * Persisted master output level from device settings: `volume` (0–100) and
 * `muted`. Written server-side when an operator dispatches set_volume/set_mute
 * (and by the display-settings PATCH), and read here so a reloaded/rebooted
 * player restores the operator's level instead of resetting to 100%.
 */

export const DEFAULT_OUTPUT_VOLUME = 100;

/** Allowlist read of settings.volume; anything invalid means full volume. */
export function readOutputVolume(settings: unknown): number {
  const raw = (settings as { volume?: unknown } | null | undefined)?.volume;
  if (typeof raw !== "number" || !Number.isFinite(raw)) {
    return DEFAULT_OUTPUT_VOLUME;
  }
  return Math.max(0, Math.min(100, Math.round(raw)));
}

/** Allowlist read of settings.muted; anything but `true` means unmuted. */
export function readOutputMuted(settings: unknown): boolean {
  const raw = (settings as { muted?: unknown } | null | undefined)?.muted;
  return raw === true;
}
